import React, { Component } from 'react'
import { Form, Input, Select, InputNumber, message, Modal } from 'antd'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

const propTypes = {}

class ItemQuickAdd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      content: null,
      filtered: [],
      selectedFilesList: null
    }
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      // percentages convert
      values.overhead = values.overhead / 100
      values.markup = values.markup / 100

      // sanitize
      values.cost =
        values.cost && typeof values.cost === 'string'
          ? values.cost.replace(/(\$|,)/g, '')
          : values.cost

      this.props.createNewItem({ values })
      form.resetFields()
      message.warning('Item created.')
      this.props.defineNewItem(values)
      this.props.toggleItemQuickAdd()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { visibility, toggleItemQuickAdd } = this.props

    return (
      <div>
        <Modal
          visible={visibility}
          title="Quick Add Item"
          okText={'Create'}
          onCancel={toggleItemQuickAdd}
          onOk={this.handleCreate}
          width={600}
          maskClosable={false}
        >
          <Form layout="vertical">
            <div className="row">
              <div className="col-md-6">
                <FormItem label="Name">
                  {getFieldDecorator('name', {
                    rules: [
                      {
                        required: true,
                        message: 'Name cannot be blank.'
                      }
                    ],
                    initialValue: this.props.itemName
                  })(<Input placeholder="Type the Item name..." />)}
                </FormItem>
              </div>
              <div className="col-md-4">
                <FormItem label="Type">
                  {getFieldDecorator('type', {
                    rules: [
                      {
                        required: true,
                        message: 'Name cannot be blank.'
                      },
                      {
                        validator: this.typeValidator
                      }
                    ]
                  })(
                    <Select style={{ width: '100%' }}>
                      <Option value="Product">Product</Option>
                      <Option value="Labor">Labor</Option>
                      <Option value="Group">Group</Option>
                      <Option value="Service">Service</Option>
                      <Option value="Material">Material</Option>
                      <Option value="Other Charge">Other Charge</Option>
                      <Option value="Sales Tax Item">Sales Tax Item</Option>
                      <Option value="Tool">Tool</Option>
                    </Select>
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <FormItem label="Cost">
                  {getFieldDecorator('cost', {})(
                    <InputNumber
                      formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    />
                  )}
                </FormItem>
              </div>
              <div className="col-md-4">
                <FormItem label="Overhead (%)">
                  {getFieldDecorator('overhead', {})(<InputNumber />)}
                </FormItem>
              </div>
              <div className="col-md-4">
                <FormItem label="Mark Up (%)">
                  {getFieldDecorator('markup', {})(<InputNumber />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Description">
                  {getFieldDecorator('description', {})(<TextArea rows={4} />)}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <FormItem label="Internal Description">
                  {getFieldDecorator('internal_description', {})(<TextArea rows={4} />)}
                </FormItem>
              </div>
            </div>
          </Form>
        </Modal>
      </div>
    )
  }
}

ItemQuickAdd.propTypes = propTypes
export default Form.create()(ItemQuickAdd)



// WEBPACK FOOTER //
// ./src/components/item/ItemQuickAdd.js